<div class="card">
  <div
    [class.card-collapsed]="props.collapsible && props.collapsed"
    [class.card-collapsible]="props.collapsible"
    (click)="toggleCollapse($event)"
    class="card-header d-flex"
  >
    <span class="flex-grow-1">
      {{ props.label }}
    </span>

    <button
      *ngIf="props.collapsible"
      (click)="toggleCollapse($event)"
      class="btn btn-link me-3 mb-0 btn-toggle-collapse w-auto"
    >
      <fa-icon [icon]="props.collapsed ? 'angle-down' : 'angle-up'"></fa-icon>
    </button>
  </div>

  <div
    [class.overflow-hidden]="props.collapsible && props.collapsed"
    class="card-body"
    [@collapse]="props.collapsible && props.collapsed ? 'collapsed' : 'expanded'"
  >
    <ng-container #fieldComponent></ng-container>
  </div>
</div>
